<template>
  <div class="bg-white-900 mb-14 mt-2">
    <div class="container mx-auto">
      <base-breadcrumbs :links-list="breadcrumbsList" class="mb-6" />
      <card-publisher-detail class="mb-12" />
      <tab-navigation
        @set-current-tab="setCurrentTab"
        :currentTab="currentTab"
        :tabs="tabs"
        class="mb-5"
      />
      <actions-bar
        v-if="currentTabComponent.actionsBar"
        :title="currentTabComponent.title"
        :placeholder="currentTabComponent.placeholder"
        :export-button="currentTabComponent.actionsButton"
        :select-type="currentTabComponent.tabData"
        title-class="text-2xl"
      />
      <keep-alive>
        <component
          :is="`tab-${currentTabComponent.tabData}`"
          :show-publishers="false"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import CardPublisherDetail from "@/components/cards/CardPublisherDetail.vue";
import TabNavigation from "@/components/base/TabNavigation.vue";
import TabCatalogs from "@/components/tabs/Catalogs.vue";
import TabBooks from "@/components/tabs/Books.vue";
import TabInformation from "@/components/tabs/Information.vue";
import ActionsBar from "@/components/base/ActionsBar.vue";
import Breadcrumbs from "@/components/base/Breadcrumbs.vue";

export default {
  name: "PublisherDetail",
  components: {
    "tab-navigation": TabNavigation,
    "card-publisher-detail": CardPublisherDetail,
    "tab-catalogs": TabCatalogs,
    "tab-books": TabBooks,
    "tab-information": TabInformation,
    "actions-bar": ActionsBar,
    "base-breadcrumbs": Breadcrumbs,
  },
  data() {
    return {
      currentTab: 0,
      tabs: [
        {
          id: 0,
          name: "All Catalogs",
          tabData: "catalogs",
          actionsBar: true,
          actionsButton: false,
          placeholder: "Search by name",
          title: "Catalogs total: 27",
        },
        {
          id: 1,
          name: "All Books",
          tabData: "books",
          actionsBar: true,
          actionsButton: true,
          placeholder: "Search by name, author, ISBN",
          title: "Books total: 350",
        },
        {
          id: 2,
          name: "Information Page",
          tabData: "information",
          actionsBar: false,
        },
      ],
      breadcrumbsList: [
        {
          href: "/publishers",
          text: "Publishers",
        },
        {
          href: "/publishers/1/",
          text: "Epigram Bookshop",
        },
      ],
    };
  },
  computed: {
    currentTabComponent() {
      return this.tabs.find((tab) => tab.id === this.currentTab);
    },
  },
  methods: {
    setCurrentTab(tabId) {
      this.currentTab = tabId;
    },
  },
};
</script>
